import EnumProjectType from "@/components/sidebar/enums/EnumProjectType";
import { ShortProfile } from "./ShortProfile";
import { BaseProjectTagItem } from "./BaseProjectTagItem";

export class BaseProjectResponse {
  Id!: number;
  Name!: string;
  Status!: EnumProjectType;
  FolderId!: string;
  IsFavorite: boolean = false;
  Admins!: Array<ShortProfile>;
  ImageUrl!: string;
  OwnerId!: number;
  PreviewColor!: string;
  Tags!: Array<BaseProjectTagItem>;
  WeeekEnable: boolean = false;
  constructor(obj?: Partial<BaseProjectResponse>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
